<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Descontos">
      <crud-base
        :url="url"
        :columns="columns"
        :onDelete="() => {}"
        :enableSearch="true"
        :checkAlerts="true"
        :reload="reload"
        @reload="onReloadConsumed"
      >
        <template #header-buttons>
          <CButton color="primary" size="sm" @click="openNovo">
            Novo registro
          </CButton>
        </template>

        <template #action-buttons="{ model }">
          <CButton
            size="sm"
            color="primary"
            title="Alterar"
            @click="openEditar(model)"
          >
            <fa-icon icon="pencil-alt" />
          </CButton>
        </template>
      </crud-base>

      <DescontoFormModal :editing="editing" @saved="onSaved" />
    </CTab>
  </CTabs>
</template>

<script>
import CrudBase from "../../components/crud/CrudBase";
import DescontoFormModal from "./DescontoFormModal";
import { dateFilter } from "@/filters/dateFilter";
import { formatPercent } from "@/filters/monetary";
import { yesNoRepresentation } from "@/helpers/transformers";

export default {
  name: "descontos",
  components: {
    CrudBase,
    DescontoFormModal,
  },
  data() {
    return {
      url: "/admin/descontos",
      editing: null,
      reload: false,
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "Descrição", field: "descricao", sortable: false },
        { label: "Dt. Início", field: "dtinicio", sortable: false, representedAs: (row) => dateFilter(row.dtinicio) },
        { label: "Dt. Final", field: "dtfim", sortable: false, representedAs: (row) => dateFilter(row.dtfim) },
        { label: "Perc. Desc", field: "percdesconto", sortable: false, representedAs: (row) => formatPercent(row.percdesconto) },
        { label: "Ativo", field: "ativo", sortable: false, representedAs: (row) => yesNoRepresentation(row.ativo) },
      ],
    };
  },
  methods: {
    openNovo() {
      this.editing = null;
      this.$nextTick(() => this.$modal.show('desconto-form'));
    },
    openEditar(row) {
      this.editing = { ...row };
      this.$nextTick(() => this.$modal.show('desconto-form'));
    },
    onSaved() {
      this.reload = true;
    },
    onReloadConsumed(value) {
      this.reload = value;
    },
  },
};
</script>
